<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="makeDeposit" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="Office" prop="officeId">
            <!-- Disable if officeId prop is supplied -->
            <el-select type="number" v-model="form.officeId" placeholder="Select"
              :disabled="this.officeId !== undefined">
              <el-option v-for="office in formattedOffices" :key="office.id" :label="office.name" :value="office.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Type" prop="typeId">
            <!-- Disable if typeId prop is supplied -->
            <el-select type="number" v-model="form.typeId" placeholder="Select" :disabled="this.typeId !== undefined">
              <el-option v-for="type in transactionTypes" :key="type.id" :label="type.name" :value="type.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Check #" prop="checkNumber">
            <el-input type="number" v-model="form.checkNumber" placeholder="Check Number" />
          </el-form-item>
          <el-form-item label="Amount" prop="amount">
            <el-input type="number" v-model="form.amount" placeholder="Amount to Deposit" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="makeDeposit">Make Deposit</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';
import map from 'lodash/map';
import api from '@/api';
import { Required } from '@/util/formValidators';
import { TRANSACTION_TYPE_LIST } from '@/enum/TransactionType';
import OfficeToRefType from '@/util/OfficeToRefType';

const formDefaultState = () => ({
  officeId: undefined,
  amount: undefined,
  typeId: undefined,
  checkNumber: undefined,
});

export default {
  name: 'MakeDepositDialog',
  props: {
    officeId: {
      type: Number,
      default: undefined,
    },
    typeId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      form: formDefaultState(),
      rules: {
        officeId: [Required],
        amount: [Required],
        typeId: [Required],
        checkNumber: [Required],
      },
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    makeDeposit() {
      this.$refs.makeDeposit.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          api.deposit.create(this.form).then(() => {
            this.$notify.success({
              title: 'Success',
              message: 'The deposit has been recorded.',
              position: 'bottom-right',
            });
            this.$emit('depositSubmitted');
            this.clearForm();
            this.closeDialog();
          }).catch((e) => {
            this.errorMessage = get(e, 'response.data', 'An error occurred.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.$emit('close');
      this.clearForm();
    },
    clearForm() {
      this.referral = { ...formDefaultState(), ...{ officeId: this.officeId, typeId: this.typeId } };
      this.errorMessage = null;
    },
  },
  computed: {
    ...mapGetters('Lookup', ['allOffices']),
    transactionTypes() {
      return TRANSACTION_TYPE_LIST;
    },
    formattedOffices() {
      return map(this.allOffices, office => OfficeToRefType(office));
    },
  },
  watch: {
    officeId() {
      this.form.officeId = this.officeId;
    },
    typeId() {
      this.form.typeId = this.typeId;
    },
  },
  mounted() {
    this.getOffices();
    if (this.officeId) {
      this.form.officeId = this.officeId;
    }
    if (this.typeId) {
      this.form.typeId = this.typeId;
    }
  },
};

</script>
